if(!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    #post_timer_text;
    #selectors;
    #template;
    #timeUnits;
    #endDate;
    #timer;

    constructor() {
      super();
      this.#post_timer_text = this.dataset.post_timer_text;
      this.#selectors = {
        textOutput: ".js-text-output",
        semicolon: ".js-semicolon",
        firstNumberOutput: ".js-first-number-output",
        secondNumberOutput: ".js-second-number-output",
      };
      this.#template = this.querySelector("div");
      this.#timeUnits = {
        days: 24 * 60 * 60,
        hours: 60 * 60,
        minutes: 60,
        seconds: 1,
      };
      this.#endDate = new Date(
        this.dataset.date.trim().replace(" ", "T")
      ).getTime();
      this.#timer = 0;
    }

    connectedCallback() {
      this.innerHTML = "";
      this.#createOutputs();
      this.#updateCountdown();
      setTimeout(() => {
        this.classList.remove('opacity-0', 'translate-y-1/4')
      }, 500);
      this.interval = setInterval(this.#updateCountdown.bind(this), 1000);
    }

    #createOutputs() {
      Object.keys(this.#timeUnits).forEach((unit, index) => {
        const counterTemplate = this.#template.cloneNode(true);
        counterTemplate.dataset.unit = unit;
        counterTemplate.querySelector(this.#selectors.textOutput).textContent =
          window.countdownStrings[unit].singular;
        if (index && index === Object.keys(this.#timeUnits).length - 1) {
          counterTemplate.querySelector(this.#selectors.semicolon).remove();
        }
        this.appendChild(counterTemplate);
      });
    }

    #updateCountdown() {
      const now = new Date(window.shop.hours).getTime();
      this.#timer += 1000;
      let remainingTime = Math.max(
        0,
        Math.floor((this.#endDate - now - this.#timer) / 1000)
      );

      if (remainingTime === 0) {
        if (this.#post_timer_text !== "") {
          this.innerHTML = this.#post_timer_text;
        } else {
          Object.keys(this.#timeUnits).forEach((unit) =>
            this.#updateUnit(unit, 0)
          );
        }
        return;
      }

      Object.entries(this.#timeUnits).forEach(([unit, seconds]) => {
        const value = Math.floor(remainingTime / seconds);
        remainingTime %= seconds;
        this.#updateUnit(unit, value);
      });
    }

    #updateUnit(unit, value) {
      const unitWrapper = this.querySelector(`[data-unit="${unit}"]`);
      if (["days", "hours"].includes(unit)) {
        unitWrapper.style.display = value > 0 ? "" : "none";
      }

      const textOutput = unitWrapper.querySelector(this.#selectors.textOutput);
      textOutput.textContent =
        value <= 1
          ? window.countdownStrings[unit].singular
          : window.countdownStrings[unit].plural;

      const outputs = [
        unitWrapper.querySelector(this.#selectors.firstNumberOutput),
        unitWrapper.querySelector(this.#selectors.secondNumberOutput),
      ];

      const newOutputs = [Math.floor(value / 10), value % 10];

      newOutputs.forEach((newOutput, index) => {
        const output = outputs[index];
        if (parseInt(output.textContent) === newOutput) {
          return;
        }
        if (this.dataset.animate !== "true" || this.#timer === 1000) {
          output.textContent = newOutput;
          return;
        }

        const firstAnim = output.animate(
          [
            { transform: "translateY(0)", opacity: 1 },
            { transform: "translateY(-50%)", opacity: 0 },
          ],
          {
            duration: 200,
            easing: "ease-out",
            fill: "forwards",
          }
        );

        firstAnim.onfinish = () => {
          output.textContent = newOutput;
          output.style.transform = "translateY(50%)";
          output.animate(
            [
              { transform: "translateY(50%)", opacity: 0 },
              { transform: "translateY(0)", opacity: 1 },
            ],
            {
              duration: 200,
              easing: "ease-out",
              fill: "forwards",
            }
          );
        };
      });
    }
  }

  customElements.define("countdown-timer", CountdownTimer);
}
